import { render, staticRenderFns } from "./manage-layout.vue?vue&type=template&id=0f44f019&"
import script from "./manage-layout.vue?vue&type=script&lang=js&"
export * from "./manage-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports